export default "__VITE_ASSET__a51aec3f__"